'use client';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { ProductDataCategory } from '~/apis/search';

export const useStoredSearchCategory = (category?: ProductDataCategory) => {
  const queryClient = useQueryClient();
  const queryKey = useMemo(() => ['searchCategory'], []);
  const { data } = useQuery({
    queryKey,
    placeholderData: (prev) => prev,
  });

  useEffect(() => {
    if (!category) return;
    queryClient.setQueryData(queryKey, category);
  }, [queryClient, queryKey, category]);

  return category ?? (data as ProductDataCategory);
};
